import { css } from '@emotion/css';
import { AlignItems, Color, Display, FlexDirection, Font, JustifyContent, Spacing, TextAlign } from 'src/styles';

export const title = css`
  ${Font.md}
`;

export const subtitle = css`
  ${Font.sm}
  ${Spacing.p4}
  color: ${Color.Gray6};
`;

export const container = css`
  ${Display.flex}
  ${AlignItems.center}
  ${JustifyContent.flexStart}
`;

export const header = css`
  ${Display.flex}
  ${FlexDirection.column}
  ${AlignItems.flexStart}
  ${JustifyContent.flexStart}
  width: 100%;
`;

export const subContainer = css`
  ${Display.flex}
  ${FlexDirection.columnReverse}
  ${AlignItems.flexStart}
  ${JustifyContent.flexStart}
  ${TextAlign.left}
  ${Spacing.pl24}
  width: 100%;
`;

export const alert = css`
  ${Spacing.m0}
  ${Spacing.p8}
`;
